// extracted by mini-css-extract-plugin
export var hideEditor = "_ls-2";
export var infoIcon = "_ls-3";
export var label = "_ls-1";
export var labelContainer = "_ls-0";
export var readonlyText = "_ls-4";